import { lumi } from '@/lib/lumi'
import { useState } from 'react'

interface ACTConversion {
  _id: string
  userId: string
  actScore: number
  satEquivalent: number
  percentile: number
  notes?: string
  creator: string
  createdAt: string
  updatedAt: string
}

export function useACTConversions() {
  const [conversions, setConversions] = useState<ACTConversion[]>([])
  const [loading, setLoading] = useState(false)

  const fetchConversions = async () => {
    setLoading(true)
    try {
      const { list } = await lumi.entities.act_conversions.list({
        sort: { createdAt: -1 },
        limit: 50
      })
      setConversions(list)
      console.log('ACT conversions fetched:', list)
    } catch (error) {
      console.error('Failed to fetch conversions:', error)
    } finally {
      setLoading(false)
    }
  }

  const saveConversion = async (data: {
    actScore: number
    satEquivalent: number
    percentile: number
    notes?: string
  }) => {
    try {
      const user = lumi.auth.user
      if (!user) {
        console.warn('User not authenticated, skipping save')
        return null
      }

      const conversion = await lumi.entities.act_conversions.create({
        ...data,
        userId: user.userId,
        creator: user.userId,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      })
      console.log('ACT conversion saved:', conversion)
      await fetchConversions()
      return conversion
    } catch (error) {
      console.error('Failed to save conversion:', error)
      throw error
    }
  }

  const deleteConversion = async (id: string) => {
    try {
      if (typeof id !== 'string' || id === '[object Object]') {
        throw new Error('Invalid ID: must be a string, not an object')
      }
      await lumi.entities.act_conversions.delete(id)
      console.log('Conversion deleted:', id)
      await fetchConversions()
    } catch (error) {
      console.error('Failed to delete conversion:', error)
      throw error
    }
  }

  return {
    conversions,
    loading,
    fetchConversions,
    saveConversion,
    deleteConversion
  }
}
